export const fundingSourcesMap = {
  singleBudgetCode: { id: 1 },
  singleBudgetCodeAllotments: { id: 2, isBudgetingRequired: true },
  multipleBudgetCodes: { id: 3 },
  editableBlank: { id: 4 },
};

export const fundingSourceTypesMap = Object.fromEntries(
  Object.entries(fundingSourcesMap).map(([key, value]) => [key, value.id])
);

export const singleBudgetCodes = [
  fundingSourceTypesMap.singleBudgetCode,
  fundingSourceTypesMap.singleBudgetCodeAllotments,
];
